// globals.css is imported from index.css so both share one Tailwind graph.
import "./index.css";

import type { BeforeSendFn } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import resumeStore from "./app/store";

const container = document.getElementById("root");

// Browsers raise this when a ResizeObserver misses a frame. Nothing breaks and it carries no
// stack, so it only drowns out the real errors.
const dropResizeObserverNoise: BeforeSendFn = (event) => {
	if (event?.event !== "$exception") return event;

	const thrown = (event.properties?.$exception_list ?? []) as Array<{ value?: string }>;

	return thrown.some((entry) => entry.value?.startsWith("ResizeObserver loop")) ? null : event;
};

const options = {
	api_host: "https://us.i.posthog.com",
	// SPA route changes don't fire $pageview by default; needed for page-based funnels
	capture_pageview: "history_change" as const,
	before_send: dropResizeObserverNoise,
};

const root = createRoot(container);
root.render(
	<React.StrictMode>
		<PostHogProvider apiKey="phc_hIy7CdutfB6hxbWmEdyduGmHTOYcFPrCZB0VihR1vjx" options={options}>
			<Provider store={resumeStore}>
				<App />
			</Provider>
		</PostHogProvider>
	</React.StrictMode>,
);
